module.exports = __webpack_public_path__ + "static/img/case-mobile-diagram-04.c6ce538.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/case-mobile-diagram-04.png
// module id = hrEo
// module chunks = 1